import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { FIELDS, FIELDS_BY_AUTH_METHOD } from './fields';
import {
  Wrapper,
  Field,
  Label,
  Input,
  Hint
} from './styled';

const CredentialsFields = ({ authMethod = null, values, onChange }) => {
  const intl = useIntl();
  const fieldNames = FIELDS_BY_AUTH_METHOD[authMethod] || [];

  return (
    <Wrapper>
      {fieldNames.map((name) => {
        const {
          labelId,
          type,
          placeholderId,
          hintId
        } = FIELDS[name];

        return (
          <Field key={ name }>
            <Label htmlFor={ `mcp-${name}` }>{intl.formatMessage({ id: labelId })}</Label>
            <Input
              autoComplete="off"
              id={ `mcp-${name}` }
              onChange={ (event) => onChange(name, event.target.value) }
              placeholder={ placeholderId ? intl.formatMessage({ id: placeholderId }) : '' }
              spellCheck={ false }
              type={ type }
              value={ values[name] || '' }
            />
            {hintId && <Hint>{intl.formatMessage({ id: hintId })}</Hint>}
          </Field>
        );
      })}
    </Wrapper>
  );
};

CredentialsFields.propTypes = {
  authMethod: PropTypes.string,
  values: PropTypes.objectOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired
};

export default CredentialsFields;
